import { createServerFn } from "@tanstack/react-start";
import { eq, desc, and } from "drizzle-orm";
import { z } from "zod";
import { getDb, schema } from "../db/client.server";
import { requireAuth, requirePermission } from "../auth/session.server";
import { sendTestEnquiryNotification } from "../email/enquiry-notification.server";

export const testEnquiryNotification = createServerFn({ method: "POST" }).handler(async () => {
  await requirePermission("settings", "manage_site");
  await sendTestEnquiryNotification();
  return { ok: true };
});

export const listContacts = createServerFn({ method: "GET" })
  .inputValidator(z.object({ status: z.string().optional(), search: z.string().optional() }).optional())
  .handler(async ({ data }) => {
    await requirePermission("contacts", "read");
    const db = getDb();
    let query = db.select().from(schema.contactEnquiries).orderBy(desc(schema.contactEnquiries.createdAt));
    const rows = await query;
    if (data?.status) return rows.filter((r) => r.status === data.status);
    return rows;
  });

export const updateContactStatus = createServerFn({ method: "POST" })
  .inputValidator(z.object({ id: z.string().uuid(), status: z.enum(["new", "read", "archived"]) }))
  .handler(async ({ data }) => {
    await requirePermission("contacts", "write");
    await getDb().update(schema.contactEnquiries).set({ status: data.status }).where(eq(schema.contactEnquiries.id, data.id));
    return { ok: true };
  });

export const exportContactsCsv = createServerFn({ method: "GET" }).handler(async () => {
  await requirePermission("contacts", "read");
  const rows = await getDb().select().from(schema.contactEnquiries).orderBy(desc(schema.contactEnquiries.createdAt));
  const header = "id,name,email,company,phone,designation,message,source,status,created_at";
  const lines = rows.map((r) =>
    [r.id, r.name, r.email, r.company, r.phone, r.designation, r.message, r.source, r.status, r.createdAt?.toISOString()]
      .map((v) => `"${String(v ?? "").replace(/"/g, '""')}"`)
      .join(","),
  );
  return { csv: [header, ...lines].join("\n") };
});

export const getDashboardStats = createServerFn({ method: "GET" }).handler(async () => {
  await requireAuth();
  const db = getDb();
  const enquiries = await db.select().from(schema.contactEnquiries).where(eq(schema.contactEnquiries.status, "new"));
  const draftInsights = await db.select().from(schema.insights).where(eq(schema.insights.status, "draft"));
  const publishedInsights = await db.select().from(schema.insights).where(eq(schema.insights.status, "published"));
  return {
    newEnquiries: enquiries.length,
    draftInsights: draftInsights.length,
    publishedInsights: publishedInsights.length,
  };
});
